import React from "react";
import styles from "./RadioInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import { Form } from "react-bootstrap";
import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface RadioInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

/**
 * RadioInput renders a single radio button.
 * It supports group-based selection, layout, and validation styling.
 *
 * @component
 * @param {Object} props - Component props
 * @param {FieldProps} props.field - Field configuration
 * @param {(fieldId: string, event: any) => void} props.handleChange - Value update handler
 */
const RadioInput: React.FC<RadioInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    value,
    disabled,
    radiogroup,
    show = true,
    isValid = true,
    error,
    selected
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={field}>
        <Form.Check
          type="radio"
          id={id}
          name={radiogroup}
          checked={!!value}
          disabled={disabled}
          onChange={(e) => handleChange(id, e)}
          onBlur={() => handleBlur(id)}
          onFocus={() => handleSelect(id)}
          isInvalid={!isValid}
          className={`${styles.customRadioInput} ${selected ? CommonStyles.selectedField : ""}`}
        />
        {!isValid && error && (
          <div className="invalid-feedback d-block">{error}</div>
        )}
      </LabeledInputWrapper>
    </div>
  );
};

export default RadioInput;
